import { TextField, TextFieldProps } from '@mui/material';
import React, { FC } from 'react';

import getPlaceholder from '../../../utils/placeholder';

import MuiIcon from '../MuiIcon';

import * as Styled from './styled';

/**
 * Search input component
 *
 * @param props Props passed to the component
 * @returns     The component itself
 */
const SearchField: FC<TextFieldProps> = props => {
  const {
    required,
    placeholder,
    // Automatically focuses the input unless explicitly overridden by passing autoFocus={false}
    autoFocus = true,
  } = props;

  /**
   * If field is required and placeholder is provided,
   * suffix * will be added
   */
  const computedPlaceholder = getPlaceholder(required === true, placeholder);

  return (
    <Styled.FormControl fullWidth={true}>
      <TextField
        {...props}
        // Disable auto-complete
        autoComplete="off"
        autoFocus={autoFocus}
        placeholder={computedPlaceholder}
        slotProps={{
          input: {
            // Remove default underline on input
            disableUnderline: true,
            startAdornment: <MuiIcon icon="search" />,
          },
        }}
        type="search"
        variant="filled"
      />
    </Styled.FormControl>
  );
};

export default SearchField;
